import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import backgroundImage from '../../assets/img/informativoimportante.jpg';
import { AppContext } from '../../contexts/app';
import api from '../../services/api';

function InformativoImportante() {
  const navigate = useNavigate();
  const { setLoading } = useContext(AppContext);
  const [informativo, setInformativo] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data = [] } = await api.get(
          '/informativoImportantes?search=[{"field":"active", "value":true}]',
        );
        setInformativo(data.docs.length ? data.docs[0] : '');
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    })();

    return () => setInformativo('');
  }, []);

  if (!informativo) {
    return null;
  }

  return (
    <Row
      className="align-items-center p-5"
      style={{
        height: '600px',
        backgroundSize: 'cover',
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Col>
        <Row>
          <Col>
            <div className="d-flex flex-column justify-content-center">
              <h1 className="font-weight-700 text-shadow text-white text-center title-xl mt-5">
                INFORMATIVO IMPORTANTE
              </h1>
            </div>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <div className="d-flex justify-content-center">
              <a
                href={informativo.pdf_url}
                target="_blank"
                rel="noreferrer noopener"
              >
                <Button
                  className="p-2 px-4 text-white font-weight-500 zoom-105"
                  color="primary"
                  style={{
                    fontSize: '1.75rem',
                    border: '2px solid var(--white)',
                  }}
                  outline
                >
                  Ver Informativo &ensp;
                  <i className="fas fa-angle-double-right" />
                </Button>
              </a>
            </div>
          </Col>
        </Row>
        <Row className="pt-5">
          <Col>
            <div className="d-flex justify-content-center">
              <Button onClick={() => navigate('/informativos-importantes')}>
                Veja mais
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default InformativoImportante;
